import * as icon from '@tencent/docs-design-resources/document-management/tencent-docs/svg/cdn';
import * as placeholder from '@tencent/docs-design-resources/document-management/miniprogram/share-placeholder/cdn';
import * as cover from '@tencent/docs-design-resources/document-management/miniprogram/structured-cover/cdn';
import * as message from '@tencent/docs-design-resources/document-management/miniprogram/structured-message/cdn';
import * as iconPng from '@tencent/docs-design-resources/document-management/tencent-docs/png-200px/cdn';
import * as iconPng3x from '@tencent/docs-design-resources/document-management/tencent-docs/png@3x/cdn';
import * as favicon from '@tencent/docs-design-resources/document-management/tencent-docs/favicon/cdn';
import * as privateTDocs from '@tencent/docs-design-resources/document-management/private-tdocs/png-200px/cdn';
import * as privateTDocsSvg from '@tencent/docs-design-resources/document-management/private-tdocs/svg/cdn';
var iconUrl = icon.default;
var sharePlaceholderUrl = placeholder.default;
var structuredCoverUrl = cover.default;
var structuredMessageUrl = message.default;
var iconPngUrl = iconPng.default;
var faviconUrl = favicon.default;
var privateTDocsUrl = privateTDocs.default;
var privateTDocsSvgUrl = privateTDocsSvg.default;
var iconPng3xUrl = iconPng3x.default;
export { iconUrl, sharePlaceholderUrl, structuredCoverUrl, structuredMessageUrl, iconPngUrl, faviconUrl, privateTDocsUrl, privateTDocsSvgUrl, iconPng3xUrl };
//# sourceMappingURL=icons.js.map